// extracted by mini-css-extract-plugin
export var headerCell = "_56-1";
export var loadingSpinnerContainer = "_56-4";
export var loadingStateCell = "_56-5";
export var rowWrapper = "_56-3";
export var standaloneTable = "_56-6";
export var table = "_56-0";
export var white = "_56-2";